import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import urlencode from 'urlencode';


import { connect } from 'react-redux';
import openWithAppTalk from '../../utils/openWithAppTalk';
import openWithApp from "../../utils/openWithApp";

class WishlistBridgePage extends Component {
  static propTypes = {
    device: PropTypes.instanceOf(Immutable.Map).isRequired,
    url: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.handleOpenApp = this.handleOpenApp.bind(this);
    this.handleOpenIntent = this.handleOpenIntent.bind(this);
  }

  componentDidMount() {
    this.handleOpenApp();
  }

  handleOpenApp() {
    const { device, url } = this.props;
    const customUrl = `inappbrowser?url=${urlencode(url)}`;
    const deviceOs = device.getIn(['os', 'name']);
    const scheme = deviceOs === 'iOS' ? process.env.REACT_APP_TALK_CUSTOM_SCHEME : 'kakaotalk';

    const osCode = device.getIn(['os', 'name']);
    const intentUrl = `intent://${customUrl}#Intent;scheme=${scheme};package=com.kakao.talk;end`;
    const customScheme = `${scheme}://${customUrl}`;

    console.log('openApp osCode:' + osCode);
    if (osCode === 'Android') {
      console.log('intentUrl: ' + intentUrl);
      window.location = customScheme;
      //intent://inappbrowser?url=https://sandbox-pf-link.kakao.com/wishlist/info#Intent;scheme=kakaotalk;package=com.kakao.talk;end`;
      //inappbrowser
    } else if (osCode === 'iOS') {
      const clickedAt = +new Date;

      // 카카오톡내에서 실행된 경우 app 이 설치된 것으로 판단하고 appStoreUrl 띄우지 않음
      const uagent = navigator.userAgent.toLocaleLowerCase();
      if (uagent.search('kakaotalk') < 0) {
        setTimeout(function () {
          if (+new Date - clickedAt < 2000) {
            window.location = url;
          }
        }, 1500);
      }

      window.location = customScheme;
    } else {
      window.open(url);
    }
  }

  handleOpenIntent() {
    const intentUrl = this.refs.intentUrl.value.trim();
    alert(intentUrl);
    window.location = intentUrl;
  }

  handleClose(e) {
    e && e.preventDefault();
    openWithAppTalk(this.props.device, 'web/close', 'kakaotalk');
  }

  getCloseCustomUrl(osCode) {
    if (osCode === 'Android') {
      return 'kakaoweb://closeBrowser';
    } else if (osCode === 'iOS') {
      return 'kakaotalk://inappbrowser/close';
    }
    return;
  }

  render() {
    const customUrl = `inappbrowser?url=${(this.props.url)}`;
    const intentUrl = `intent://${customUrl}#Intent;scheme=kakaotalk;package=com.kakao.talk;S.browser_fallback_url=https://www.daum.net;end`;
    const customScheme = `kakaotalk://${customUrl}`;


    return (
      <div style={{ height: '100%' }}>
        <div id="kakaoWrap">
          <div id="kakaoHead" className="head_bridge" role="banner">
            <h1 className="tit_logo">
              <a href="#none" className="link_logo" style={{ padding: 0 }}>
                <span className="ico_plus ico_logo">카카오톡 채널</span>
              </a>
            </h1>
          </div>

          <hr className="hide" />

          <div id="kakaoContent" className="cont_bridge" role="main">
            <div className="inner_bridge">
              <span className="img_bridge" />
              <strong className="tit_bridge">카카오톡 실행이 필요합니다.</strong>
              <p className="desc_bridge">
                채널 콘텐츠를 확인하기 위해서는<br /> 카카오톡을 실행해야합니다.<br />
              </p>
              <a href="#none" className="btn_talk btn_type1" onClick={this.handleOpenInstallPage}>
                카카오톡 최신 버전 설치하기
              </a>
              <a href={intentUrl} className="btn_talk btn_type2">
                카카오톡으로 안드로이드 인텐트 열기1
              </a>
              <a href={customScheme} className="btn_talk btn_type2">
                카카오톡으로 안드로이드 인텐트 열기2
              </a>
              <a href="#none" className="btn_talk btn_type2" onClick={() => { window.open(this.props.url); }}>
                톡찜 안내페이지 열기
              </a>
            </div>
          </div>

        </div>
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const { device, entities } = state;
  const url = entities.get('url');
  return { device, url, ...ownProps };
};

export default connect(mapStateToProps)(WishlistBridgePage);


// WEBPACK FOOTER //
// ./src/containers/WishListInfoPage/WishlistBridgePage.js